import { motion } from 'framer-motion'
import { ChevronDown } from 'lucide-react'

interface ScrollArrowProps {
  text?: string
}

const ScrollArrow = ({ text = 'Scroll' }: ScrollArrowProps) => {
  return (
    <motion.div
      className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer z-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 0.8 }}
      onClick={() => {
        window.scrollBy({ top: window.innerHeight, behavior: 'smooth' })
      }}
    >
      <span className="text-[10px] text-white/40 uppercase tracking-[0.3em] font-mono">
        {text}
      </span>
      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        <ChevronDown className="w-5 h-5 text-white/40" />
      </motion.div>
    </motion.div>
  )
}

export default ScrollArrow
